<!--进场费用分析-->
<template>
    <div>
        <Form ref="applicationForm" :model="application" :rules="applicationRules" inline :label-width="125"
              class="form-common">
            <FormItem label="开始日期" prop="startDate">
                <DatePicker type="date" v-model="application.startDate" placeholder="开始日期"
                            format="yyyy-MM-dd"
                            @on-change="onStartDateChange"
                            style="width: 200px"></DatePicker>
            </FormItem>
            <FormItem label="结束日期" prop="endDate">
                <DatePicker type="date" v-model="application.endDate" placeholder="结束日期"
                            format="yyyy-MM-dd"
                            @on-change="onEndDateChange"
                            style="width: 200px"></DatePicker>
            </FormItem>
            <br/>
            <FormItem class="btn-groups">
                <Button type="primary" @click="handleSubmit">查询</Button>
                <ExportButton api="report/getJinchangListDao" :disabled="exportDisabled" :params="exportParams">导出
                </ExportButton>
            </FormItem>
        </Form>
        <CTable border :columns="columns" :data="queryData" @change="change"
                :showPage="false" :row-class-name="rowClassName" height="500" />

    </div>
</template>

<script>
    import CTable from '@/components/CTable'
    import BtnEvent from '@/components/BtnEvent'
    import {timeFormat, amountFormat, repalceGetParamsByObj} from '@/plugin/tool'
    import {auditStatusList, auditList} from '@/plugin/enum'
    import CusInputView from "../../components/CusInput/CusInputView";
    import ExportButton from "../../components/ExportButton";

    export default {
        name: "EntranceFee",
        mixins: [BtnEvent],
        components: {
            ExportButton,
            CusInputView,
            CTable
        },
        computed: {
            exportParams() {
                return this.application
            },
            exportDisabled() {
                return !this.application.startDate || this.application.startDate.length === 0 || !this.application.endDate || this.application.endDate === 0
            }
        },
        data() {
            return {
                date: [],
                vdate: [],//用于选择审核通过日期
                cusList: [],
                application: {
                    page: 1,
                    pageSize: 10,
                    startDate: null,
                    endDate: null,
                },
                applicationRules: {
                    startDate: [
                        {required: true, message: '请输入开始时间', trigger: 'change'}
                    ],
                    endDate: [
                        {required: true, message: '请输入结束时间', trigger: 'change'}
                    ],
                },
                spList: auditList,
                total: 0,
                queryData: [], // 表格数据
                columns: [
                    {
                        fixed: 'left',
                        title: '区域',
                        key: 'area',
                        align: 'center',
                        width: 100
                    },
                    {
                        fixed: 'left',
                        title: '终端类型',
                        key: 'zdType',
                        align: 'center',
                        width: 200
                    },
                    {
                        title: '全新超市/卖场',
                        align: 'center',
                        children: [
                            {
                                title: '数量',
                                key: 'quanQty',
                                align: 'center',
                                width: 100
                            },
                            {
                                title: '进场费',
                                key: 'quanJin',
                                align: 'center',
                                width: 200
                            }
                        ]
                    },
                    {
                        title: '现有超市新门店',
                        align: 'center',
                        children: [
                            {
                                title: '数量',
                                key: 'xianQty',
                                align: 'center',
                                width: 100
                            },
                            {
                                title: '进场费',
                                key: 'xianJin',
                                align: 'center',
                                width: 200
                            }
                        ]
                    },
                    {
                        title: '现有超市添加品种',
                        align: 'center',
                        children: [
                            {
                                title: '数量',
                                key: 'tianQty',
                                align: 'center',
                                width: 100
                            },
                            {
                                title: '进场费',
                                key: 'tianJin',
                                align: 'center',
                                width: 200
                            }
                        ]
                    }
                ],
            }
        },
        created() {
        },
        methods: {
            handleCusSuccess(cus) {
                this.application.cusName = cus.cusName
            },
            queryCus(value) {
                this.$fetch('SysCus/getCodeName', {
                    cusName: value
                }).then(res => {
                    this.cusList = res.data.list
                })
            },
            handleSubmit() { // 查询表单校验
                console.log(this.application)
                this.$refs.applicationForm.validate((valid) => {
                    if (valid) {
                        this.application.page = 1
                        this.queryTableData()
                    } else {
                        console.log(valid)
                    }
                })
            },
            queryTableData() { // 查询表格
                this.$fetch('report/getJinchangList', this.application).then(res => {
                    this.queryData = res.data
                })
            },
            change(index) {
                this.application.page = index
                this.queryTableData()
            },
            onEndDateChange(val) {
                this.application.endDate = timeFormat(val, 'date')
            },
            onStartDateChange(val) {
                this.application.startDate = timeFormat(val, 'date')
            },
            handleClickExport() {
                this.application.startDate = timeFormat(this.date[0], 'date')
                this.application.closeDate = timeFormat(this.date[1], 'date')
                this.application.shenBeginDate = timeFormat(this.vdate[0], 'date')
                this.application.shenEndDate = timeFormat(this.vdate[1], 'date')
                this.application.cusCode = null;
                _.forEach(this.cusList, value => {
                    if (value.cusName === this.application.cusName) {
                        this.application.cusCode = value.cusCode
                    }
                })


                //点击了导出按钮
                window.location.href = window.location.origin + `/api/SalesPromo/downSalesProExcel?` + repalceGetParamsByObj(this.application)
            },
            rowClassName(row, index) {
                if (row.zdType === '小计') {
                    return 'demo-table-info-row';
                } else if (row.zdType === '总计') {
                    return 'demo-table-error-row';
                } else if (row.zdType === '合计') {
                    return 'demo-table-heji-row'
                }
                return '';
            },
            handleSummary ({ columns, data }) {
                debugger
                console.log(columns,data)
                const sums = {};
                columns.forEach((column, index) => {
                    const key = column.key;
                    if (index === 0) {
                        sums[key] = {
                            key,
                            value: '总价'
                        };
                        return;
                    }
                    const values = data.map(item => Number(item[key]));
                    if (!values.every(value => isNaN(value))) {
                        const v = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    } else {
                        sums[key] = {
                            key,
                            value: 'N/A'
                        };
                    }
                });

                return sums;
            }
        }
    }
</script>

<style scoped>

</style>
